export default __webpack_public_path__ + "static/media/element_66.3d422db4.avif";